// extracted by css-extract-rspack-plugin
export default {"spinnerWrapper":"_58da8b1c"};